import { Link, useNavigate } from "react-router-dom";
import NoData from "../../assets/img/nodata_green.svg";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  TypePaymentLinkCollection,
  fetchPaymentLinks,
  resetCursor,
  selectPaymentLinks,
  TypePaymentLink,
} from "../../features/paymentlinks/paymentLinksSlice";
import { useEffect, useState } from "react";
import { formatDate } from "../../helpers/commons";
import {
  selectNtumaAccount,
  selectAccessToken,
  selectActiveEnvironment,
} from "../../features/auth/authSlice"; //update here
import DropdownButton from "../elements/DropdownButton";
import AppSpinner from "../elements/AppSpinner";

import axios, { AxiosError } from "axios";

import { APP_STATUS, BASE_URL } from "../../helpers/constants";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";

import useApiRequest from "../../helpers/api_request";
import { SHORTEN_URL } from "../../helpers/constants";

const PaymentLinksPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const paymentLinks = useAppSelector(selectPaymentLinks);
  const ntumaAccount = useAppSelector(selectNtumaAccount);
  const loadingLinksStatus = useAppSelector(
    (state) => state.paymentLinks.loadingLinksStatus
  );
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = useAppSelector((state) => state.paymentLinks.totalPages);
  const landingUrl = process.env.REACT_APP_LANDING_URL;

  const apiRequest = useApiRequest();
  const [longUrl, setLongUrl] = useState("");

  useEffect(() => {
    dispatch(resetCursor());
    dispatch(fetchPaymentLinks());
  }, [ntumaAccount]);

  const sumCollections = (data: TypePaymentLinkCollection[]): string => {
    let totalAmount = 0;
    for (const item of data) {
      if (item.collection) {
        if (item.collection.status === "successful") {
          totalAmount += item.collection.amount;
        }
      }
    }
    return totalAmount.toLocaleString();
  };

  const copyLink = (value: string) => {
    dispatch(
      showToastMessage({
        message: "Copied",
        type: "success",
        position: toast.POSITION.TOP_RIGHT,
      })
    );
    navigator.clipboard.writeText(value);
  };

  useEffect(() => {
    if (longUrl) {
      const fetchShortenedUrl = async () => {
        
        //const apiUrl = SHORTEN_URL.API_HOST;
        const apiUrl = BASE_URL+"/api/payment-link/shorten_url";
        const toastLoader = toast.loading("Processing"); // This shows the loading toast

        try {
          const response = await apiRequest({
            method: "post",
            url: apiUrl,
            headers: { "Content-Type": "application/json" },
            data: {
              long_url: longUrl,
            },
          });

          toast.dismiss(toastLoader); // Dismiss toast after response

          if (response.status === "SUCCESS") {
            const getShortenedUrl = response.short_url;

            copyLink(getShortenedUrl);
          } else {
            dispatch(
              showToastMessage({
                message: response.message,
                type: "error",
                position: toast.POSITION.TOP_RIGHT,
              })
            );
          }
        } catch (error) {
          dispatch(
            showToastMessage({
              message: "Failed to process shortened URL.",
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        } finally {
          toast.dismiss(toastLoader); 
        }
      };

      fetchShortenedUrl();
    }
  }, [longUrl]);

  //new-code

  console.log("Payment-Links" + JSON.stringify(paymentLinks));

  const [disablePaymentLink, setDisablePaymentLink] = useState<{
    [key: number]: boolean;
  }>({});
  const [paymentLinkId, setPaymentLinkId] = useState<{ [key: number]: number }>(
    {}
  );
  const accessToken = useAppSelector(selectAccessToken);
  const activeEnvironment = useAppSelector(selectActiveEnvironment);

  const disableOrDisablePaymentLink = async (
    item: TypePaymentLink,
    isChecked: boolean
  ) => {
    // Confirmation dialog
    const confirmMessage = isChecked
      ? `Disable payment link:"${item.title}"?`
      : `Enable payment link: "${item.title}"?`;

    if (!window.confirm(confirmMessage)) return;

    try {
      setPaymentLinkId({ [item.id]: item.id });

      setDisablePaymentLink((prev) => ({
        ...prev,
        [item.id]: isChecked,
      }));

      const dataUrl = `${BASE_URL}/api/payment-link/enable_or_disable/${item.id}`;

      const toastLoader = toast.loading("Processing");

      await apiRequest({
        method: "post",
        url: dataUrl,
        headers: {
          Authorization: "Bearer " + accessToken,
        },
        data: {
          is_disabled: isChecked,
          env: activeEnvironment,
        },
      })
        .then((response) => {
          console.log("API-DISABLE/ENABLE" + JSON.stringify(response));

          if (response.status == "success") {
            toast.success("Payment link updated successfully! ");
          } else {
            toast.error("Unable to change payment link status");
          }

          toast.dismiss(toastLoader);
        })
        .catch((error) => {
          const errorResponse = error as AxiosError;
          if (errorResponse.response) {
            const data = errorResponse.response.data as {
              message: string;
              status: string;
            };
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error("Something went wrong", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
          toast.dismiss(toastLoader);
        });
    } catch (error) {
      console.error("API error:", error);
      toast.error("Unable to complete request");
    }
  };

  return (
    <div>
      <div className="card mb-12">
        <div className="card-body flex flex-col px-4 py-4 min-h-half-screen pb-16">
          <div className="flex">
            <nav className="flex justify-between " aria-label="Breadcrumb">
              <ol className="inline-flex items-center mb-3 sm:mb-0">
                <li>
                  <div className="flex items-center">
                    <h5 className=" card-title ">Payment Links</h5>
                  </div>
                </li>
              </ol>
            </nav>
            <div className="flex-grow flex justify-end">
              <button
                onClick={() => navigate("/new-payment-link")}
                type="button"
                className="prim-btn-1 mb-2"
              >
                New Payment Link
              </button>
            </div>
          </div>

          {paymentLinks.length === 0 &&
            loadingLinksStatus != APP_STATUS.PENDING && (
              <div className=" h-fit flex-grow flex flex-col justify-center ">
                <div className="flex justify-center">
                  <div>
                    <img className=" w-32" src={NoData} alt="" />
                    <p>No Payment Links Yet!</p>
                  </div>
                </div>
              </div>
            )}
          {paymentLinks.length > 0 && (
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead>
                <tr>
                  <th scope="col">Title</th>
                  <th scope="col">Type</th>
                  <th scope="col">Price</th>
                  <th scope="col">Created</th>
                  <th scope="col">Collections</th>
                  <th>Disabled</th>
                </tr>
              </thead>
              <tbody>
                {paymentLinks.map((item, key) => (
                  <tr key={key}>
                    <td>{item.title}</td>
                    <td>
                      {item.fixed_amount ? "Fixed Charge" : "Dynamic Charge"}
                    </td>
                    <td>{item.amount.toLocaleString()}</td>
                    <td>{formatDate(item.created_at, "MMM DD, YYYY H:mm")}</td>
                    <td>
                      <Link
                        to={"/live/" + item.ref}
                        className="font-bold text-prim-green"
                      >
                        {sumCollections(item.collections)}
                      </Link>
                    </td>

                    <td
                      style={{ textAlign: "center", verticalAlign: "middle" }}
                    >
                      <input
                        type="checkbox"
                        checked={
                          disablePaymentLink[item.id] ??
                          item.is_disabled === true
                        }
                        onChange={(e) =>
                          disableOrDisablePaymentLink(item, e.target.checked)
                        }
                      />
                    </td>

                    <td>
                      <div className=" ">
                        <a
                          onClick={() =>
                            copyLink(landingUrl + "/pay/" + item.ref)
                          }
                          href="#!"
                          className="font-medium text-prim-green  hover:underline"
                        >
                          copy
                        </a>
                        <Link
                          to={"/payment-links/edit/" + item.ref}
                          className=" fa fa-edit text-gray-500 ml-3 text-xs"
                        ></Link>
                        <Link
                          to={"#"}
                          className="fa fa-link text-gray-500 ml-3 text-xs"
                          onClick={() => {
                            const generatedUrl =
                              landingUrl + "/pay/" + item.ref;
                            console.log("Original URL:", generatedUrl);

                            setLongUrl(generatedUrl);
                          }}
                        ></Link>
                        {/* <DropdownButton
                                        options={
                                          [ {text:"Collections", onClick:()=>{}}, {text:"Edit", onClick:()=>{}} ]
                                          
                                        }
                                      buttonClass="btn btn-light px-2 py-[5px] ml-4 text-xs text-gray-600" /> */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {loadingLinksStatus === APP_STATUS.PENDING && <AppSpinner />}
          {currentPage < totalPages && (
            <div className=" flex justify-center mt-16">
              <button
                onClick={() => {
                  setCurrentPage(currentPage + 1);
                  dispatch(fetchPaymentLinks());
                }}
                type="button"
                className="btn-light text-gray-600 "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  className=" text-gray-600"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M14 16h5v5M10 8H5V3m14.418 6.003A8 8 0 0 0 5.086 7.976m-.504 7.021a8 8 0 0 0 14.331 1.027"
                  />
                </svg>
                <span className="pl-1">Load More</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default PaymentLinksPage;
